module.exports = __webpack_public_path__ + "static/media/validacao_cpf_dark.10b99cf6.svg";